<template>
	<!-- v-if="personnelInfo !== null" -->
	<div class="home-heard">
		<div class="home-heard-menu">
			<img class="home-heard-menu-img" src="../assets/imgs/logo1.png" />
			<el-menu
				:default-active="activeIndex"
				class="el-menu-demo home-heard-menu-ul"
				mode="horizontal"
				@select="handleSelect"
				active-text-color="#409EFF"
			>
				<el-menu-item index="1"
					><router-link to="/">{{
						$t("menuList.home")
					}}</router-link></el-menu-item
				>

				<el-menu-item index="2">
					<router-link to="/aboutUs">
						{{ $t("menuList.aboutUs") }}
					</router-link>
				</el-menu-item>
				<!-- <el-menu-item index="3">
						<router-link to="/product">{{
							$t("menuList.products")
						}}</router-link></el-menu-item
					> -->
				<el-submenu index="3">
					<template slot="title">{{
						$t("menuList.products")
					}}</template>
					<el-menu-item index="3-3-1"
						><router-link :to="{name:'product',query:{categoriesName: 'PMOLED',categoriesName1:  'DISPLAY' ,productType: 'OLED'}}">{{ $t("menuList.oledDisplay") }}</router-link>
						<!-- <router-link to="/product"
							>{{ $t("menuList.oledDisplay") }}</router-link
						> -->
						</el-menu-item
					>
					<el-menu-item index="3-3-2"
						><router-link :to="{name:'product',query:{categoriesName: 'PMOLED',categoriesName1: 'MODULE',productType: 'OLED'}}"
							>{{ $t("menuList.oledModule") }}</router-link
						></el-menu-item
					>
					<el-menu-item index="3-3-3"
						><router-link :to="{name:'product',query:{categoriesName: 'AMOLED',categoriesName1: 'DISPLAY',productType: 'OLED'}}"
							>{{ $t("menuList.amOledDisplay") }}</router-link
						></el-menu-item
					>
					<el-menu-item index="3-3-4"
						><router-link :to="{name:'product',query:{categoriesName: '',categoriesName1: 'DISPLAY',productType: 'MICRO-OLED'}}"
							>{{ $t("menuList.oledoSDisplay") }}</router-link
						></el-menu-item
					>
					<el-menu-item index="3-3-5"
						><router-link :to="{name:'product',query:{categoriesName: '',categoriesName1: 'DISPLAY',productType: 'TFT'}}"
							>{{ $t("menuList.tftDisplay") }}</router-link
						></el-menu-item
					>
				</el-submenu>
				<el-submenu index="4-4-1">
					<template slot="title">{{
						$t("menuList.aboutIndustrial")
					}}</template>
					<el-menu-item index="4-4-1"
						><router-link to="/Internet"
							>Box</router-link
						></el-menu-item
					>
					<el-menu-item index="4-4-2"
						><router-link to="/Internet/HMI"
							>HMI</router-link
						></el-menu-item
					>
					<el-menu-item index="4-4-3"
						><router-link to="/Internet/PLC"
							>PLC</router-link
						></el-menu-item
					>
				</el-submenu>
				<el-menu-item index="5">
					<router-link to="/productTechnology">{{
						$t("menuList.Technology")
					}}</router-link></el-menu-item
				>
				<el-menu-item index="6">
					<router-link to="/contact">{{
						$t("menuList.contactUs")
					}}</router-link>
				</el-menu-item>
			</el-menu>
			<div class="right-box">
				<ul
					role="menubar"
					class="el-menu-demo el-menu--horizontal el-menu"
				>
					<li>
						<a href="https://twitter.com/"
							><img src="../assets/imgs/Twitter.jpg"
						/></a>
					</li>
					<li>
						<a href="https://www.facebook.com/"
							><img src="../assets/imgs/Facebook.jpg"
						/></a>
					</li>
					<li>
						<a
							href="https://www.youtube.com/"
							><img src="../assets/imgs/Youtude.jpg"
						/></a>
					</li>
					<li>
						<a
							href="https://www.linkedin.com/in/anker-ruan-4a62b51bb"
							><img src="../assets/imgs/LinkedIn.jpg"
						/></a>
					</li>
					<li>
						<a
							href="https://plus.google.com/"
							><img src="../assets/imgs/Google+.jpg"
						/></a>
					</li>
					<li>
						<a
							href="https://www.instagram.com/"
							><img src="../assets/imgs/ins.jpg"
						/></a>
					</li>
				</ul>
				<div class="el-icon">
					<div class="phone el-icon-phone-outline">
						{{ personnelInfo.personnelPhone }}
					</div>
					<div class="email el-icon-message">
						{{ personnelInfo.personnelEmail }}
					</div>
					<div class="lang" @click="switchLocale">
						{{ $t("links.chinese") }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from "vuex";

export default {
	data() {
		return {
			activeIndex: "1",
			companyImgZ: require("../assets/imgs/z-company.jpg"),
			companyImgE: require("../assets/imgs/e-company.jpg"),
			companyImg: "",
			personnelInfo: {},
		};
	},
	computed: {
		...mapState({
			locale: "locale",
		}),
	},
	watch: {
		locale(val) {
			this.companyImg =
				val === "zh-CN" ? this.companyImgZ : this.companyImgE;
		},
		$route(to) {
			this.setRoute(to.path);
			
		},
	},
	created() {
		this.getPersonnelInfo();
		this.setRoute(this.$route.path);
		this.$store.commit("SET_LANG", this.$cookies.get("SET_LANG"));
	},
	methods: {
		setRoute(path) {
			if (path === "/product" || path.indexOf("/product/") > -1) {
				this.activeIndex = "3";
			} else if (path === "/") {
				this.activeIndex = "1";
			} else if (path === "/aboutUs") {
				this.activeIndex = "2";
			} else if (path.indexOf("/Internet") > -1) {
				this.activeIndex = "4-4-1";
			} else if (path === "/productTechnology") {
				this.activeIndex = "5";
			} else if (path === "/contact") {
				this.activeIndex = "6";
			}

		},
		handleSelect(key) {
			location.reload();
			this.activeIndex = key;
		},
		myHandleSelect(index) {
			this.activeIndex = index;
		},
		switchLocale() {
			let locale = this.locale === "en-US" ? "zh-CN" : "en-US";
			// let locale = this.locale === "zh-CN" ? "en-US" : "zh-CN";
			this.$i18n.locale = locale;
			this.$store.commit("SET_LANG", locale);
			// cookies.set("SET_LANG", locale);
			this.$cookies.set("SET_LANG", locale);
			// this.$router.go(0); // 设置国际化，更新页面
			location.reload();
		},
		getPersonnelInfo() {
			this.$axios.post(`selectPersonnelInfo`).then((res) => {
				this.personnelInfo = res.data.data[0];
			});
		},
	},
};
</script>
<style lang="scss">
.home-heard {
	position: fixed;
	top: 0;
	z-index: 999;
	width: 100vw;
	border-bottom: 1px solid #e6e6e6;
	.home-heard-company {
		display: flex;
		justify-content: space-between;
		position: relative;
		background: #fff;
		padding: 0 24px;
		img {
			height: 70px;
		}
	}
	.home-heard-menu {
		display: flex;
		padding-left: 24px;
		position: relative;
		background: #fff;
		img {
			height: 70px;
		}
		.home-heard-menu-img {
			padding-top: 10px;
		}
		.home-heard-menu-ul {
			padding-top: 10px;
		}
		.el-menu-item a {
			display: inline-block;
			height: 100%;
		}
		.el-menu--horizontal {
			border: 0;
			.el-menu-item.is-active {
				font-weight: 600;
			}
		}
		.right-box {
			position: absolute;
			right: 70px;
			.el-menu-demo {
				display: flex;
				justify-content: flex-end;
				li {
					padding: 8px;
				}
				img {
					width: 25px !important;
					height: 25px;
				}
			}
			.el-icon {
				padding-top: 10px;
			}
			> div {
				display: flex;
				div {
					padding: 0 8px;
				}
			}
			.lang {
				cursor: pointer;
				color: #409eff;
				font-size: 16px;
			}
		}
	}
	.el-menu {
		.el-menu-item.is-active {
			.el-dropdown {
				color: #409eff;
			}
		}
	}
	.shenniuHref {
		text-align: right;
		height: 45px;
		line-height: 45px;
	}
	.list-inline {
		padding-left: 0;
		margin-left: -5px;
		list-style: none;
	}
}
.popper__arrow {
	display: none !important;
}
.el-popper[x-placement^="bottom"] {
	margin: 0;
}
.el-popper .popper__arrow {
	border-width: 0;
}
.el-popper[x-placement^="bottom"] .popper__arrow {
	top: 0;
}
.el-popper .popper__arrow,
.el-popper .popper__arrow::after {
	border-style: none;
}
.el-menu-item a {
	display: inline-block;
	height: 100%;
	width: 100%;
}
.el-menu .is-active a {
	font-weight: 600;
}
.el-menu--popup {
	min-width: 140px !important;
}
</style>
